<template>
  <div class="video-player-page" @click="toggleControls">
    <!-- 全屏视频播放器 -->
    <div class="video-container" ref="videoContainer">
      <video
        ref="videoPlayer"
        :src="videoUrl"
        controls
        autoplay
        playsinline
        webkit-playsinline
        class="fullscreen-video"
        @loadedmetadata="onVideoLoaded"
        @click.stop="togglePlayPause"
      ></video>
    </div>

    <!-- 自定义控制栏 -->
    <div v-show="showControls" class="custom-controls" @click.stop>
      <div class="controls-top">
        <van-icon name="arrow-left" class="close-icon" @click="goBack" />
        <div class="video-title-text">{{ videoTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoPlayer",
  data() {
    return {
      videoUrl: "",
      videoTitle: "",
      showControls: true,
      controlsTimer: null,
    };
  },
  mounted() {
    // 获取视频URL和标题
    const urlParam = this.$route.query.videoUrl;
    this.videoUrl = urlParam ? decodeURIComponent(urlParam) : "";
    this.videoTitle = this.$route.query.title || "视频播放";

    // 延迟进入全屏，确保页面已渲染
    this.$nextTick(() => {
      setTimeout(() => {
        this.requestFullscreen();
        this.startControlsTimer();
      }, 300);
    });

    // 监听全屏状态变化
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "MSFullscreenChange",
      this.handleFullscreenChange
    );
  },
  beforeDestroy() {
    this.clearControlsTimer();
    this.exitFullscreen();
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "MSFullscreenChange",
      this.handleFullscreenChange
    );
  },
  beforeDestroy() {
    this.clearControlsTimer();
    this.exitFullscreen();
  },
  methods: {
    onVideoLoaded() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.volume = 1;
        video.muted = false;

        video.play().catch((error) => {
          console.log("自动播放失败", error);
        });
      }
    },
    togglePlayPause() {
      const video = this.$refs.videoPlayer;
      if (video) {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      }
      this.startControlsTimer();
    },
    toggleControls() {
      this.showControls = !this.showControls;
      if (this.showControls) {
        this.startControlsTimer();
      } else {
        this.clearControlsTimer();
      }
    },
    startControlsTimer() {
      this.clearControlsTimer();
      this.controlsTimer = setTimeout(() => {
        this.showControls = false;
      }, 3000);
    },
    clearControlsTimer() {
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
        this.controlsTimer = null;
      }
    },
    requestFullscreen() {
      const container = this.$refs.videoContainer;
      if (container) {
        if (container.requestFullscreen) {
          container.requestFullscreen();
        } else if (container.webkitRequestFullscreen) {
          container.webkitRequestFullscreen();
        } else if (container.mozRequestFullScreen) {
          container.mozRequestFullScreen();
        } else if (container.msRequestFullscreen) {
          container.msRequestFullscreen();
        }
      }
    },
    exitFullscreen() {
      if (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      ) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    handleFullscreenChange() {
      // 如果退出全屏，返回上一页
      if (
        !document.fullscreenElement &&
        !document.webkitFullscreenElement &&
        !document.mozFullScreenElement &&
        !document.msFullscreenElement
      ) {
        this.goBack();
      }
    },
    goBack() {
      this.exitFullscreen();
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.video-player-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullscreen-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.custom-controls {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10000;
}

.controls-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.6) 0%,
    transparent 100%
  );
  pointer-events: auto;
}

.close-icon {
  font-size: 24px;
  color: #fff;
  cursor: pointer;
  margin-right: 15px;
  z-index: 10001;
}

.video-title-text {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
